<div
  class="wrapper"
  *ngIf="voucherGroup | async as voucherGroup; else loading"
>
  <mat-card
    class="activate-card"
    *ngIf="township && theme; else loading"
  >
    <div
      class="logo-wrapper"
      *ngIf="logoImg"
    >
      <img
        [src]="logoImg"
        alt="logo"
        class="logo"
      />
    </div>
    <div class="sub-title">
      {{ 'activate.body.header_text' | translate }}
    </div>
    <div class="title">{{ voucherGroup.name }}</div>
    <div
      class="img-wrapper"
      *ngIf="headerImg"
      style="background-image: url('{{ headerImg }}')"
    ></div>
    <div
      class="sub-title"
      *ngIf="startDate"
    >
      Het vindt plaats op {{ startDate | date : 'dd-MM-YYYY' }} om
      {{ startDate | date : 'HH:mm' }}
    </div>
    <mat-card-content>
      <form
        class="activate-voucher-form"
        (ngSubmit)="submit()"
        [formGroup]="activateVoucherForm"
      >
        <mat-form-field>
          <mat-label>{{ 'input.name' | translate }}</mat-label>
          <input
            formControlName="name"
            matInput
            required
            autocomplete="name"
          />
          <mat-error>
            {{ getError('name') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'input.email' | translate }}</mat-label>
          <input
            formControlName="email"
            matInput
            required
            autocomplete="email"
          />
          <mat-error>
            {{ getError('email') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'input.confirm-email' | translate }}</mat-label>
          <input
            formControlName="emailConfirm"
            matInput
            required
            autocomplete="email"
          />
          <mat-error>
            {{ getError('emailConfirm') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="voucherGroupData.verifyPhone">
          <mat-label>{{ 'input.phone' | translate }}</mat-label>
          <input
            minlength="10"
            maxlength="10"
            formControlName="phone"
            matInput
            required
            autocomplete="tel-national"
            placeholder="0612345678"
          />
          <mat-error>
            {{ getError('phone') }}
          </mat-error>
        </mat-form-field>
        <mat-checkbox
          class="checkbox"
          formControlName="available"
        >
          {{ 'activate.body.available' | translate }}
        </mat-checkbox>
        <!-- <mat-checkbox class="checkbox" formControlName="unavailable">
          {{ 'activate.body.unavailable' | translate }}
        </mat-checkbox> -->
        <mat-form-field>
          <mat-label>{{ 'input.remarks' | translate }}</mat-label>
          <input
            formControlName="remarks"
            matInput
            autocomplete="none"
          />
          <mat-error>
            {{ getError('remarks') }}
          </mat-error>
        </mat-form-field>
        <mat-label class="general-terms">
          <span>{{ 'activate.body.terms.read-terms' | translate }} </span>
          <a
            href="{{ townshipUrlFixed }}"
            target="_blank"
          >
            {{ 'activate.body.terms.terms-condition' | translate }}
          </a>
          <span>{{ 'activate.body.terms.here' | translate }}</span>
        </mat-label>
        <mat-checkbox
          class="checkbox terms-cb"
          formControlName="terms"
        >
          {{ 'activate.body.terms.accept' | translate }}
        </mat-checkbox>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <button
        [class.spinner]="awaitingResponse"
        (click)="submit()"
        mat-flat-button
      >
        {{ 'activate.buttons.enter_availability' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
<!-- </div> -->
<ng-template #loading>
  <div class="loading-wrapper">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</ng-template>
